import { type AuthError } from '@atlaskit/outbound-auth-flow-client';

import {
	AnalyticsActionSubject,
	AnalyticsAction,
	type ScopeState,
	type Integration,
} from '../../../types';
import { BaseInvitePeopleAnalytics, type FailedFetchAttributes } from '../../../analytics';

export class ThirdPartyContextAnalytics extends BaseInvitePeopleAnalytics {
	integrationsFetched(attributes: { integrations: string[] }) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.THIRD_PARTY_INTEGRATIONS,
			action: AnalyticsAction.FETCHED,
			attributes,
		});
	}

	fetchExistingIntegrationsFailed(
		attributes: {
			ari: string;
		} & FailedFetchAttributes,
	) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.FETCH_EXISTING_INTEGRATIONS,
			action: AnalyticsAction.FAILED,
			attributes,
		});
	}

	integrationConnected({
		previousStatus = 'neverConnected',
		serviceKey,
		teamId,
		auto = false,
	}: {
		previousStatus?: ScopeState | 'neverConnected';
		serviceKey: string;
		teamId?: string;
		auto?: boolean;
	}) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.THIRD_PARTY_INTEGRATION,
			action: AnalyticsAction.CONNECTED,
			attributes: {
				integration: serviceKey,
				teamId,
				auto,
				previousStatus,
			},
		});
	}

	integrationFailed(serviceKey: string, error?: AuthError) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.THIRD_PARTY_INTEGRATION,
			action: AnalyticsAction.FAILED,
			attributes: {
				integration: serviceKey,
				errorType: error ? error.type : undefined,
			},
		});
	}

	sloThirdPartyInitSuccess(attributes: {
		enabledIntegrations: Integration[];
		connectedIntegrations: Integration[];
		selectedSlackWorkspace: string | undefined;
	}) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.SLO_THIRD_PARTY_INIT,
			action: AnalyticsAction.SUCCEEDED,
			attributes,
		});
	}

	sloThirdPartyInitFailed(error: string | undefined) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.SLO_THIRD_PARTY_INIT,
			action: AnalyticsAction.FAILED,
			attributes: {
				error,
			},
		});
	}

	thirdPartyInitFailed(error: string | undefined) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.THIRD_PARTY_INIT,
			action: AnalyticsAction.FAILED,
			attributes: {
				error,
			},
		});
	}

	slackChannelFailed(errorMessage?: string, status?: number) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.SLACK_CHANNEL,
			action: AnalyticsAction.FAILED,
			attributes: {
				context: 'invite-user-picker',
				pickerType: 'multi',
				errorMessage,
				status,
			},
		});
	}

	getSlackChannelsSucceeded() {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.GET_SLACK_CHANNELS,
			action: AnalyticsAction.SUCCEEDED,
		});
	}

	getSlackChannelsFailed() {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.GET_SLACK_CHANNELS,
			action: AnalyticsAction.FAILED,
		});
	}
}
